import React from "react";
import { AlertBox } from "@/components/Form/Fields/AlertBox";
import { TextInput } from "@/components/Form/Fields/TextInput";
import { SelectField } from "@/components/Form/Fields/Select";
import { RadioField } from "@/components/Form/Fields/Radio";
import { CheckBox } from "@/components/Form/Fields/Checkbox";
import Date from "@/components/Form/Fields/Date";
import { DateProps, FieldProps, SelectFieldProps } from "@/components/Form/Fields/types";
import { FieldValues } from "react-hook-form";
import AddAdditionalPhoneNumber from "@/components/Form/Fields/addAdditionalPhoneNumber";

// Mapeo de tipos de input a sus respectivos componentes
export const fieldComponents: Record<
  string,
  React.FC<FieldProps> | React.FC<SelectFieldProps> | React.FC<DateProps<FieldValues>> | any
> = {
  TextInput: TextInput,
  TextArea: TextInput,
  email: TextInput,
  number: TextInput,
  tel: TextInput,
  Select: SelectField,
  Check: CheckBox,
  Radio: RadioField,
  Date: Date,
  AlertBox: AlertBox,
  AddAdditionalPhoneNumber: AddAdditionalPhoneNumber,
};
